export default {"src":"/_next/static/media/0x82af49447d8a07e3bd95bd0d56f35241523fbab1.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};